import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Reframe } from './components/Reframe';
import { DailyInsights } from './components/DailyInsights';
import { ProgramOverview } from './components/ProgramOverview';
import { Results } from './components/Results';
import { WhatYouGet } from './components/WhatYouGet';
import { VisualResults } from './components/VisualResults';
import { AboutAuthor } from './components/AboutAuthor';
import { ProgramPhases } from './components/ProgramPhases';
import { TargetAudience } from './components/TargetAudience';
import { Bonuses } from './components/Bonuses';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-[#050510] text-gray-300 selection:bg-cyan-500/30 selection:text-cyan-100" data-id="element-0">
      <Navbar data-id="element-1" />
      <Hero data-id="element-2" />
      <PainPoints data-id="element-3" />
      <Reframe data-id="element-4" />
      <DailyInsights data-id="element-5" />
      <ProgramOverview data-id="element-6" />
      <Results data-id="element-7" />
      <WhatYouGet data-id="element-8" />
      <VisualResults data-id="element-9" />
      <AboutAuthor data-id="element-10" />
      <ProgramPhases data-id="element-11" />
      <TargetAudience data-id="element-12" />
      <Bonuses data-id="element-13" />
      <Guarantee data-id="element-14" />
      <FAQ data-id="element-15" />
      <FinalCTA data-id="element-16" />
      <Footer data-id="element-17" />
    </main>;
}